import { motion } from "framer-motion";

const rungs = [
  {
    lvl: "Tener",
    desc: "Franquicias, distribución, Mamma Pasta en todos lados.",
    tag: "Lo que querés",
    color: "#1d4a8c",
  },
  {
    lvl: "Hacer",
    desc: "Producción, procesos, sistema, calidad artesanal.",
    tag: "Lo que ya tenés",
    color: "#4F46E5",
  },
  {
    lvl: "Ser",
    desc: "El significado de la marca: qué es, por qué la eligen, qué se transfiere.",
    tag: "Lo que falta",
    color: "#7ab7fd",
  },
];

const MammaCapas = () => {
  return (
    <section
      id="capas"
      className="py-24 md:py-32 relative overflow-hidden"
      style={{
        background: "linear-gradient(180deg, hsl(220 69% 2%), hsl(215 48% 14%))",
      }}
    >
      <div className="container px-4 max-w-4xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
          className="text-center mb-14"
        >
          <span
            className="text-xs md:text-sm font-semibold tracking-[0.25em] uppercase mb-5 block"
            style={{ color: "#7ab7fd" }}
          >
            Cómo lo vemos
          </span>
          <h2 className="font-display text-3xl md:text-5xl font-bold text-white leading-[1.1]">
            Toda marca se sostiene
            <br />
            <span style={{ color: "#7ab7fd" }}>sobre tres capas.</span>
          </h2>
        </motion.div>

        <div className="space-y-4 mb-12">
          {rungs.map((r, i) => (
            <motion.div
              key={r.lvl}
              initial={{ opacity: 0, x: -20 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: i * 0.12 }}
              className="rounded-2xl border p-6 md:p-7 flex flex-col md:flex-row md:items-center gap-3 md:gap-8"
              style={{
                borderColor: `${r.color}55`,
                background: `linear-gradient(100deg, ${r.color}22, rgba(255,255,255,0.02))`,
                marginLeft: `${i * 0}px`,
              }}
            >
              <span
                className="font-display text-2xl md:text-3xl font-bold md:w-40 shrink-0"
                style={{ color: r.color === "#1d4a8c" ? "#7ab7fd" : r.color }}
              >
                {r.lvl}
              </span>
              <span className="flex-1 text-sm md:text-base text-white/80 leading-relaxed">
                {r.desc}
              </span>
              <span className="text-[10px] md:text-xs uppercase tracking-[0.2em] text-white/50 whitespace-nowrap">
                {r.tag}
              </span>
            </motion.div>
          ))}
        </div>

        <motion.p
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.4 }}
          className="text-base md:text-lg text-white/70 leading-relaxed text-center max-w-2xl mx-auto"
        >
          Construiste el <span className="text-white font-medium">Hacer</span> y
          apuntás al <span className="text-white font-medium">Tener</span>. Pero el
          Tener no llega sin el <span className="text-white font-medium">Ser</span>:
          la franquicia no se vende porque falta el cimiento que le da sentido a
          todo lo demás. Por eso empezamos por ahí —y desde ahí se construye todo
          lo que sigue.
        </motion.p>
      </div>
    </section>
  );
};

export default MammaCapas;
